import httpManager from "@/app/shared/utils/httpManager";

export async function replicateTemplateFromPortfolio(type, from, to) {
  const newType = type == "contacts" ? "client" : "account";
  const body = { type: newType, portfolio_source: from };
  await httpManager.put(`/portfolios/${to}/template/replicate/`, body);
}
